module.exports = __webpack_public_path__ + "img/mapClusterDefault.339206e.svg";